export default __webpack_public_path__ + "images/f8756c42a05f93fefe42c2120a3473bd.svg";